import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingCheckoutEntrySection from "../../../sections/CheckoutEntry";
import MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry from "../../../sections/DirectiveEntry/entries/DiagnosticEntry";

const DiagnosticEntryCompleted = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckoutEntrySection />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry />
    </>
  );
}

export default DiagnosticEntryCompleted;
